import { useState, useEffect, forwardRef } from "react";
import CreateNewModal from "./shorts-series/create_content_modal";
import { AxiosInstance } from "../../common/Loader/axios.config";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { FaUpload } from "react-icons/fa6";
import UploadVideoModal from "./shorts-series/upload_video";
import EditVideoModal from "./shorts-series/edit_video_modal";
import EditParentModal from "./shorts-series/edit_parent_modal";
import { FaFolderOpen } from "react-icons/fa";

const ShortsSeriesUpload = forwardRef((props, ref) => {
  const { setUploadStatus, setProgress } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isEditVideoModalOpen, setIsEditVideoModalOpen] = useState(false);
  const [content, setContent] = useState([]);
  const [selectedSeries, setSelectedSeries] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [selectedParent, setSelectedParent] = useState(null);
  const [isEditParentModalOpen, setIsEditParentModalOpen] = useState(false);

  useEffect(() => {
    AxiosInstance.get("/new-content")
      .then((response) => {
        const allContent = response.data.message;

        // Filter content based on type
        const filteredContent = allContent.filter((content) =>
          ["shorts", "series"].includes(content.category)
        );

        const sortedContent = filteredContent.sort((a, b) => {
          return (
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
          );
        });

        setContent(sortedContent);
      })
      .catch((error) => {
        console.error("Error fetching content:", error);
      });
  }, []);

  return (
    <div className="flex w-full flex-col items-center">
      <div className="my-4 flex w-full items-center justify-between">
        {/* Show back button if a series is selected */}
        {selectedSeries ? (
          <button
            className="bg-gray-500 rounded-full px-4 py-2 text-white"
            onClick={() => setSelectedSeries(null)}
          >
            Back
          </button>
        ) : (
          <div></div>
        )}

        {selectedSeries ? (
          <button
            className="flex items-center gap-x-1 rounded-full bg-primary px-4 py-2 text-white duration-200 hover:scale-105"
            onClick={() => setIsUploadModalOpen(true)}
          >
            <FaUpload />
            <p>Upload</p>
          </button>
        ) : (
          <button
            className="flex items-center gap-x-1 rounded-full bg-primary px-4 py-2 text-white duration-200 hover:scale-105"
            onClick={() => setIsModalOpen(true)}
          >
            <MdOutlineLibraryAdd size={24} />
            <p className="font-bold">Create New</p>
          </button>
        )}
      </div>

      {/* Show either the list of series or the videos inside a series */}
      {selectedSeries ? (
        <div className="w-full">
          <h2 className="text-xl font-bold text-black text-white">
            {selectedSeries.title}
          </h2>
          <p className="mb-4 text-white">{selectedSeries.description}</p>
          <div className="grid grid-cols-3 gap-4">
            {selectedSeries.video_content.map((video) => (
              <div
                key={video._id}
                className="relative transform rounded bg-white p-4 shadow transition-transform hover:scale-105 hover:shadow-lg"
              >
                {/* Use the selected series thumbnail instead of video.thumbnail */}
                <img
                  src={selectedSeries.thumb_nail}
                  alt={selectedSeries.title}
                  className="h-auto w-full rounded"
                />
                <h3 className="text-md font-semibold text-black">
                  {video.title}
                </h3>
                <p className="text-sm text-black">Price: MWK {video.price}</p>
                <p className="text-sm text-black">Views: {video.views}</p>

                <button
                  className="mt-2 rounded-md bg-primary px-4 py-2 text-white"
                  onClick={() => {
                    setSelectedVideo(video);
                    setIsEditVideoModalOpen(true);
                  }}
                >
                  Edit
                </button>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div
          className="grid grid-cols-3 gap-4"
        >
          {content.map((series) => (
            <div
              key={series._id}
              className="relative transform cursor-pointer rounded bg-white p-4 shadow transition-transform hover:scale-105 hover:shadow-lg">
              <img
                src={series.thumb_nail}
                alt={series.title}
                className="h-40 w-full object-cover rounded"
              />
              <h3 className="text-lg font-semibold text-black">
                {series.title}
              </h3>
              <p className="text-sm text-black">
                Videos: {series.video_content.length}
              </p>
              <p className="text-sm text-black">Price: MWK {series.price}</p>
              <p className="text-sm text-black">
                Created:{" "}
                {new Date(series.created_at).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>

              <div className="flex items-center gap-x-3">
              <button
                className="mt-2 rounded-md bg-primary px-4 py-2 text-white"
                onClick={() => {
                  setSelectedParent(series);
                  setIsEditParentModalOpen(true);
                }}
              >
                Edit
              </button>

              <button
                className="flex items-center gap-x-1 mt-2 rounded-md bg-primary px-4 py-2 text-white"
                onClick={() => {
                  setSelectedSeries(series);
                }}
              >
                <FaFolderOpen size={20} /> 
                Open
              </button>

              </div>
            </div>
          ))}
        </div>
      )}

      <CreateNewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />

      {isUploadModalOpen && (
        <UploadVideoModal
          isOpen={isUploadModalOpen}
          onClose={() => setIsUploadModalOpen(false)}
          selectedSeries={selectedSeries}
        />
      )}

      {isEditVideoModalOpen && (
        <EditVideoModal
          isOpen={isEditVideoModalOpen}
          onClose={() => setIsEditVideoModalOpen(false)}
          selectedVideo={selectedVideo}
        />
      )}

      {isEditParentModalOpen && (
        <EditParentModal
          isOpen={isEditParentModalOpen}
          onClose={() => setIsEditParentModalOpen(false)}
          selectedParent={selectedParent}
        />
      )}
    </div>
  );
});

export default ShortsSeriesUpload;
